import { useId, type InputHTMLAttributes, forwardRef } from 'react';
import { CircleAlert } from 'lucide-react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, id, className = '', ...props }, ref) => {
    const autoId = useId();
    const inputId = id ?? props.name ?? autoId;
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={inputId} className="text-sm font-medium text-fg">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`h-10 rounded-control border bg-surface-0 px-3 text-sm text-fg transition-colors duration-fast placeholder:text-fg-muted disabled:cursor-not-allowed disabled:bg-surface-2 disabled:text-fg-muted ${
            error ? 'border-danger' : 'border-line-strong'
          } ${className}`}
          aria-invalid={Boolean(error)}
          {...props}
        />
        {error && (
          <span className="flex items-center gap-1 text-xs text-danger">
            <CircleAlert size={14} aria-hidden="true" />
            {error}
          </span>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';
